<h1 mat-dialog-title>{{tituloDialog}}</h1>
<form>
  <div mat-dialog-content class="air-theme">

    <div fxLayout="row" class="flexwrap">
      <div fxFlex="45" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.area.name.label' | translate }}</mat-label>
          <input matInput [(ngModel)]="data.folder.name" name="name" required>
          <mat-error>
            {{ 'protocolEdit.dialog.area.name.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="45" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'calibrationPlan.folderInternalEquipment.dialog.father' | translate }}</mat-label>
          <mat-select name="unit" [(ngModel)]="data.folder.idFather" (selectionChange)="validateFather($event)">
            <mat-option>--</mat-option>
            @for (item of filteredEquipmentFolders; track item) {
              <mat-option [value]="item.id">
                {{item.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <mat-toolbar color="secondary">
      {{ 'calibrationPlan.folderInternalEquipment.dialog.linkedTeams' | translate }}
    </mat-toolbar>
    <mat-form-field class="campoFormulario">
      <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' | translate }}</mat-label>
      <input matInput
        (keyup)="lookupEquipment($event)">
      <mat-error>
        {{ 'calibrateEquipmentEdit.patterns.dialog.equipment.error' | translate }}
      </mat-error>
    </mat-form-field>
    <div fxLayout="row" class="flexwrap" style="max-height: 50vh;">
      @for (eq of filteredEquipments; track eq) {
        <div fxFlex="25">
          <mat-checkbox style="margin-left: 1em;" (change)="onChangeEquipmentCheck($event)" [value]="eq"
            [checked]="isEquipmentChecked(eq)">
            <span style="white-space: pre-line;">
              {{ eq.name}} ({{eq.serialNum}})
            </span>
          </mat-checkbox>
        </div>
      }
    </div>

  </div>
  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>